/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import GetINTouch from "../Contactus/GetINTouch";
import { TextField } from "@mui/material";

export default function PaymentForm() {
  const [isVerified, setIsVerified] = useState(false);
  const [errors, setErrors] = useState({});
  const [recaptchaToken, setRecaptchaToken] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [cardSelect, setCardSelect] = useState(true);

  const initialFormData = {
    firstName: "",
    lastName: "",
    email: "",
    paymentAmount: "",
    invoiceNumber: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateFrom = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.firstName) {
      newErrors.firstName = "Please Enter First Name";
    }
    if (!formData.lastName) {
      newErrors.lastName = "Please Enter Last Name";
    }
    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = "Please Valid Enter Email";
    }
    if (!formData.paymentAmount) {
      newErrors.paymentAmount = "Please Enter Payment Amount";
    }
    if (!formData.invoiceNumber) {
      newErrors.invoiceNumber = "Please Enter Invoice Number";
    }
    if (!formData.address) {
      newErrors.address = "Please Enter Address";
    }
    if (cardSelect) {
      newErrors.creditCardNumber = "Please Select Card Type";
      newErrors.expDate = "Please Select Card Type";
      newErrors.cvc = "Please Select Card Type";
    }
    if (!formData.city) {
      newErrors.city = "Please Enter City";
    }
    if (!formData.state) {
      newErrors.state = "Please Enter State";
    }
    if (!formData.zipCode) {
      newErrors.zipCode = "Please Enter Zip Code";
    }
    if (!formData.country) {
      newErrors.country = "Please Enter Country";
    }
    if (!cardSelect) {
      newErrors.creditCardNumber = "";
      newErrors.expDate = "";
      newErrors.cvc = "";
      if (!cardNumber) {
        newErrors.creditCardNumber = "Please Enter Card Number";
      }
      if (cardNumber) {
        let cleaned = cardNumber.replaceAll(" ", "");
        if (
          paymentMethod === "MasterCard" ||
          paymentMethod === "Visa" ||
          paymentMethod === "Discover"
        ) {
          if (cleaned.length !== 16)
            newErrors.creditCardNumber = "Invalid Credit Card Number";
        } else if (paymentMethod === "Amex") {
          if (cleaned.length !== 15)
            newErrors.creditCardNumber = "Invalid Credit Card Number";
        } else {
          newErrors.creditCardNumber = "Please select a valid card type";
        }
      }
      if (!expiry) {
        newErrors.expDate = "Please Enter Expiry Date";
      }
      if (expiry) {
        const now = new Date();
        const [monthStr, yearStr] = expiry.split("/");
        const expiryMonth = parseInt(monthStr);
        const expiryYear = parseInt("20" + yearStr);
        if (
          isNaN(expiryMonth) ||
          isNaN(expiryYear) ||
          expiryMonth < 1 ||
          expiryMonth > 12
        ) {
          newErrors.expDate = "Invalid Expiry Date";
        } else {
          const expiryDate = new Date(expiryYear, expiryMonth - 1, 1);
          const currentDate = new Date(now.getFullYear(), now.getMonth(), 1);
          if (expiryDate < currentDate) {
            newErrors.expDate = "Card Expired";
          }
          if (expiryYear > now.getFullYear() + 10) {
            newErrors.expDate = "Expiry year is too far in future";
          }
        }
      }
      if (!cvv) {
        newErrors.cvc = "CVV is required";
      }
      if (cvv) {
        if (cvv.length !== 3) {
          newErrors.cvc = "Invalid CVV";
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatCardNumber = (value) => {
    return value
      .replace(/\D/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };

  const formatExpiry = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 4);
    if (cleaned.length >= 3) {
      return cleaned.slice(0, 2) + "/" + cleaned.slice(2);
    }
    return cleaned;
  };

  const handleCardNumberChange = (e) => {
    setCardNumber(formatCardNumber(e.target.value));
  };

  const handleExpiryChange = (e) => {
    setExpiry(formatExpiry(e.target.value));
  };

  const handleCvvChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 3);
    setCvv(val);
  };

  const handleForm = (event) => {
    event.preventDefault();
    validateFrom();
    console.log({
      ...formData,
      cardName: paymentMethod,
      creditCardNumber: cardNumber.replaceAll(" ", ""),
      expDate: expiry,
      cvc: cvv,
    });
  };

  useEffect(() => {
    const tokenInput = document.getElementById("recaptcha-token");
    if (tokenInput && tokenInput.value) {
      setRecaptchaToken(tokenInput.value);
      setIsVerified(true);
    }
  }, []);

  const handleCaptcha = (token) => {
    if (token) {
      setRecaptchaToken(token);
      setIsVerified(true);
    } else {
      setRecaptchaToken("");
      setIsVerified(false);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
     <title>Make a Payment | Citrus Diagnostic Center Crystal River</title>
    <meta name="description" content="Citrus Diagnostic Center in Crystal River, Florida, offers a secure, convenient way for patients to make payments for medical imaging services online or onsite." />

    <div className="pt-28 sm:pt-20 md:pt-24 lg:pt-[12.0625rem]">
      <form onSubmit={(e) => handleForm(e)}>
        <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16 block w-full mx-auto">
          <div className="flex flex-col justify-center items-center">
            <div className="text-center mb-32">
              <h1 className="text-white font-robout text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] font-bold capitalize tracking-[-.04em] leading-tight">
                Make A Payment
              </h1>
              <p className="text-white mt-6 max-w-2xl mx-auto text-lg sm:text-xl font-robout">
                Please fill out the form below to securely complete payment.
                Information is protected and encrypted.
              </p>
            </div>

            <div className="grid md:grid-cols-2 grid-cols-1 xl:w-11/12 2xl:w-4/5 md:w-full w-11/12 gap-10 xl:gap-20">
              {/* Personal Details */}
              <div>
                <h3 className="text-[#d78558] font-semibold mb-2 text-2xl tracking-wide font-robout">
                  Personal Details
                </h3>
                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="firstName"
                    id="floating_email"
                    className="block py-3.5 px-0 w-full text-[1.2rem]  bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white  focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                  />
                  <label
                    for="firstName"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white  duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto   peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    First Name
                  </label>
                  {errors.firstName && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.firstName}
                    </p>
                  )}
                </div>
                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="lastName"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Last Name
                  </label>
                  {errors.lastName && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.lastName}
                    </p>
                  )}
                </div>

                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="email"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Email Address
                  </label>
                  {errors.email && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.email}
                    </p>
                  )}
                </div>

                {/* Payment Method */}
                <h3 className="text-[#d78558] font-semibold mb-2 text-2xl tracking-wide font-robout">
                  Payment Method
                </h3>
                <div className="my-8">
                  <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
                    {["MasterCard", "Visa", "Amex", "Discover"].map((card) => (
                      <button
                        aria-label="Payment Cards"
                        key={card}
                        type="button"
                        onClick={() => {
                          setPaymentMethod(card);
                          setCardSelect(false);
                        }}
                        className={`py-2 rounded ${
                          paymentMethod === card
                            ? "bg-[#d78558] text-white"
                            : "border border-[#d78558] text-white"
                        }`}
                      >
                        {card}
                      </button>
                    ))}
                  </div>
                </div>
                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="creditCardNumber"
                    id="creditCardNumber"
                    value={cardNumber}
                    onChange={handleCardNumberChange}
                    disabled={cardSelect}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="creditCardNumber"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Credit Card Number
                  </label>
                  {errors.creditCardNumber && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.creditCardNumber}
                    </p>
                  )}
                </div>

                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div class="relative z-0 w-full my-8 group">
                    <input
                      type="text"
                      name="expDate"
                      id="expDate"
                      value={expiry}
                      onChange={handleExpiryChange}
                      disabled={cardSelect}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      for="expDate"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      Expiration Date (MM/YY)
                    </label>
                    {errors.expDate && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.expDate}
                      </p>
                    )}
                  </div>

                  <div class="relative z-0 w-full my-8 group">
                    <input
                      type="text"
                      name="cvc"
                      id="cvc"
                      value={cvv}
                      onChange={handleCvvChange}
                      disabled={cardSelect}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      for="cvc"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      CVC/CVV
                    </label>
                    {errors.cvc && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.cvc}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {/* Billing Information */}
              <div>
                <h3 className="text-[#d78558] font-semibold mb-2 text-2xl tracking-wide font-robout">
                  Billing Information
                </h3>
                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="paymentAmount"
                    id="paymentAmount"
                    value={formData.paymentAmount}
                    onChange={handleChange}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="paymentAmount"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Payment Amount
                  </label>
                  {errors.paymentAmount && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.paymentAmount}
                    </p>
                  )}
                </div>

                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="invoiceNumber"
                    id="invoiceNumber"
                    value={formData.invoiceNumber}
                    onChange={handleChange}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="invoiceNumber"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Invoice Number
                  </label>
                  {errors.invoiceNumber && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.invoiceNumber}
                    </p>
                  )}
                </div>

                <div class="relative z-0 w-full my-8 group">
                  <input
                    type="text"
                    name="address"
                    id="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                    placeholder=" "
                  />
                  <label
                    for="address"
                    className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Address
                  </label>
                  {errors.address && (
                    <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                      {errors.address}
                    </p>
                  )}
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 w-full grid-cols-1 gap-4">
                  {/* City */}
                  <div class="relative z-0 w-full my-8 group">
                    <input
                      type="text"
                      name="city"
                      id="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      for="city"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      City
                    </label>
                    {errors.city && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.city}
                      </p>
                    )}
                  </div>

                  {/* State */}
                  <div class="relative z-0 w-full my-8 group">
                    <input
                      type="text"
                      name="state"
                      id="state"
                      value={formData.state}
                      onChange={handleChange}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      for="state"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      State
                    </label>
                    {errors.state && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.state}
                      </p>
                    )}
                  </div>

                  {/* Zip Code */}
                  <div class="relative z-0 w-full my-8 group">
                    <input
                      type="text"
                      name="zipCode"
                      id="zipCode"
                      value={formData.zipCode}
                      onChange={handleChange}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      for="zipCode"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      Zip Code
                    </label>
                    {errors.zipCode && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.zipCode}
                      </p>
                    )}
                  </div>

                  <div className="my-8 md:hidden">
                    <div className="relative z-0 w-full group">
                      <input
                        type="text"
                        name="country"
                        id="country"
                        value={formData.country}
                        onChange={handleChange}
                        className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                        placeholder=" "
                      />
                      <label
                        htmlFor="country"
                        className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Country
                      </label>
                      {errors.country && (
                        <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                          {errors.country}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="my-8 md:flex hidden">
                  <div className="relative z-0 w-full group">
                    <input
                      type="text"
                      name="country"
                      id="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="block py-3.5 px-0 w-full text-[1.2rem] bg-transparent border-0 border-b-2 border-[#d78558] appearance-none text-white focus:outline-none focus:ring-0 peer"
                      placeholder=" "
                    />
                    <label
                      htmlFor="country"
                      className="peer-focus:font-medium absolute text-[1.2rem] text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      Country
                    </label>
                    {errors.country && (
                      <p className="text-[#ff2b2b] font-robout text-[16px] mt-1">
                        {errors.country}
                      </p>
                    )}
                  </div>
                </div>
                {/* reCAPTCHA */}
                <div className="flex justify-center items-center w-full mb-4">
                  <div className="recaptcha-container ps-16 md:ps-0 w-full flex justify-center items-center">
                    <ReCAPTCHA
                      sitekey="6LeeTGYrAAAAAA77ABJlfNMg9D_IUhmXT-yolFod"
                      onChange={handleCaptcha}
                      theme="dark"
                    />
                  </div>
                </div>
                {/* Pay Now Button */}
                {isVerified && (
                  <div className="md:col-span-2 text-center">
                    <button   aria-label="Pay Now" className="group relative inline-flex h-14 mt-6 items-center rounded-full px-16 font-semibold text-black bg-transparent overflow-hidden">
                      <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>
                      <span className="relative">
                        <span className="flex flex-row gap-2 justify-center font-robout tracking-wider items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          PAY NOW
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 font-robout tracking-wider left-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          PAY NOW
                        </span>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <GetINTouch />
    </div>
        </>
  );
}
